"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Navbar_1 = require("./Navbar");
const Header_1 = require("./Header");
const styles_1 = require("./styles");
class SideMenuPage extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.navbar = react_1.default.createRef();
        this.state = {
            isMenuOpened: false,
        };
        this.componentDidMount = async () => {
            // TODO: arrumar essa gambiarra feiosa pra ele carregar a navbar sem precisar ser forçada
            this.setState({});
        };
    }
    render() {
        const classesPageWrapper = classnames_1.default([
            "page-wrapper",
            {
                "nav-open": this.navbar.current
                    ? this.navbar.current.state.isOpened
                    : false,
            },
        ]);
        return (react_1.default.createElement("div", { className: "wrapper" },
            react_1.default.createElement(Navbar_1.Navbar, Object.assign({ ref: this.navbar }, this.props)),
            react_1.default.createElement(styles_1.PageWrapper, { className: classesPageWrapper },
                this.navbar.current && (react_1.default.createElement(Header_1.Header, Object.assign({ isMenuOpened: this.navbar.current.state.isOpened, toggleMenu: this.navbar.current.toggleMenu, title: this.props.title }, this.props))),
                react_1.default.createElement(styles_1.PageWrapperContent, null,
                    !this.props.loading && this.props.children,
                    this.props.loading && (react_1.default.createElement("div", { className: "loader" },
                        react_1.default.createElement("img", { src: "./imagens/loading.gif", alt: "loading" })))))));
    }
}
exports.SideMenuPage = SideMenuPage;
